const CONSENT_STORAGE_NAME = 'wphConsent';

module.exports = { CONSENT_STORAGE_NAME };
